/**
 * Helpers purs pour les stats des cards form-polls dans le dashboard.
 *
 * Extrait de useDashboardData pour être testable sans mock Supabase.
 * Bug B3 (test v1→v6) : cards "0/0" malgré réponses. Root causes :
 *  1. fetch excluait response_type='form' (corrigé)
 *  2. .eq("is_test", false) excluait is_test NULL (corrigé via .or)
 *  3. comptage unique participants — verrouillé ici.
 */

export interface RawFormResponseRow {
  stable_fingerprint?: string | null;
  respondent_name?: string | null;
  device_id?: string | null;
  id?: string | null;
}

export interface FormCardStats {
  participantsCount: number;
  votesCount: number;
}

/**
 * Compte participants uniques + total réponses depuis les rows poll_responses.
 * Unicité par fingerprint > nom > device > id (fallback). Un même répondant
 * (même fingerprint) ne compte qu'une fois.
 */
export function computeFormCardStats(
  rows: RawFormResponseRow[] | undefined | null,
): FormCardStats {
  const list = rows ?? [];
  const unique = new Set(
    list.map(
      (r) =>
        r.stable_fingerprint || r.respondent_name || r.device_id || r.id || "",
    ),
  );
  // Une chaîne vide ne doit pas compter comme un participant.
  unique.delete("");
  return {
    participantsCount: unique.size,
    votesCount: list.length,
  };
}
